export enum TestPlanStatusIds {
  upcoming = 0,
  inProgress = 1,
  completed = 2,
}

export enum TestPlanState {
  upcoming = 'upcoming',
  in_progress = 'in_progress',
  completed = 'completed',
}

export interface TestPlanItemsResponse {
  data: TestPlanItem[];
}

export interface TestPlanItemAttribute {
  spree_variant_id: string | null;
  test_plan_id: number;
  state: TestPlanState | null;
  actionable_date: string | null;
  position: number;
  sku: string | null;
}

export interface TestPlanItem {
  id: string;
  type: string;
  attributes: TestPlanItemAttribute;
}

export interface TestsClassification {
  upcoming: TestPlanItem[];
  in_progress: TestPlanItem[];
  completed: TestPlanItem[];
}

type HTTPLinksType = string | null;
export interface TestHistoryLinks {
  self: HTTPLinksType;
  first: HTTPLinksType;
  prev: HTTPLinksType;
  next: HTTPLinksType;
  last: HTTPLinksType;
}
type TestHistoryMetaType = number | null;
export interface TestHistoryMeta {
  'current-page': TestHistoryMetaType;
  'next-page': TestHistoryMetaType;
  'prev-page': TestHistoryMetaType;
  'total-pages': TestHistoryMetaType;
  'total-count': TestHistoryMetaType;
}

export interface TestPlanPagination {
  links: TestHistoryLinks;
  meta: TestHistoryMeta;
}

interface TestPlanContext {
  upcomingTests: TestPlanItem[];
  inProgressTests: TestPlanItem[];
  completedTests: TestPlanItem[];
  loadingTestPlanItems: boolean;
  testPlanActiveStatus: TestPlanStatusIds;
  getTestPlanItems: () => Promise<any>;
  createTestPlanItem: (spreeVariantId: string | number) => Promise<any>;
  updateTestPlanItem: (testPlanItem: TestPlanItem) => Promise<any>;
  removeTestPlanItem: (id: string | number) => Promise<any>;
  setTestPlanActiveStatus: (id: TestPlanStatusIds) => void;
}

export type TestPlanTypes = TestPlanContext;
